import React from "react";
import { Tag } from "antd";
import { ReparationCaseStatus } from "api/requests";


interface StatusTagProps {
  status: ReparationCaseStatus;
}

// Define color and display name mappings
const statusColors: { [key in ReparationCaseStatus]: string } = {
  PENDING: "orange",
  CHECKING: "blue",
  REVISED: "purple",
  CONTACTING_CUSTOMER: "magenta",
  CUSTOMER_CONFIRMED: "volcano",
  REPAIRING: "cyan",
  COMPLETED: "green",
  PAID: "geekblue",
  CANCELLED: "red",
  PRICED: "gold",
  RECEIVED: "lime",
};

const statusDisplayNames: { [key in ReparationCaseStatus]: string } = {
  PENDING: "Pending",
  CHECKING: "Checking",
  REVISED: "Revised",
  CONTACTING_CUSTOMER: "Contacting Customer",
  CUSTOMER_CONFIRMED: "Customer Confirmed",
  REPAIRING: "Repairing",
  COMPLETED: "Completed",
  PAID: "Paid",
  CANCELLED: "Cancelled",
  PRICED: "Priced",
  RECEIVED: "Received",
};

const CaseStatusTag: React.FC<StatusTagProps> = ({ status }) => {
  return (
    <Tag color={statusColors[status]}>
      {statusDisplayNames[status]}
    </Tag>
  );
};

export default CaseStatusTag;